import { visuallyHidden } from "@mui/utils";
import { appThemeColors } from "styles/appTheme";

export const DATA_TABLE_TOOLBAR_CONTAINER = "data-table-toolbar";

export const TOOLBAR_BUTTON_LABEL_CLASS = "data-table-toolbar-btn-label";

export const TOOLBAR_ICON_ONLY_MAX_WIDTH = 1024;

export const dataTableToolbarContainerSx = {
  containerType: "inline-size",
  containerName: DATA_TABLE_TOOLBAR_CONTAINER,
};

export const toolbarIconOnlyButtonSx = {
  [`@container ${DATA_TABLE_TOOLBAR_CONTAINER} (max-width: ${TOOLBAR_ICON_ONLY_MAX_WIDTH}px)`]: {
    position: "relative",
    width: 32,
    height: 32,
    minWidth: 32,
    minHeight: 32,
    padding: 0,
    gap: 0,
    justifyContent: "center",
    border: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    "& .MuiButton-startIcon": {
      margin: 0,
    },
    "& .MuiButton-endIcon": {
      display: "none",
    },
    [`& .${TOOLBAR_BUTTON_LABEL_CLASS}`]: visuallyHidden,
    "&:hover": {
      border: "none",
      backgroundColor: appThemeColors.background.kbd,
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      border: "none !important",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
};
